import { createRouter, createWebHistory } from "vue-router";

import { LAYOUT, ROUTES } from "./utils/enums";

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: "/",
      name: ROUTES.LOGIN,
      meta: { title: "walletFrontend.login", requiresAuth: false },
      component: () => import("./views/Login.vue"),
    },
    {
      path: "/:pathMatch(.*)*",
      component: () => import("./views/Login.vue"),
    },
    {
      path: "/start",
      name: ROUTES.START,
      meta: { skipAuthCheck: true, requiresAuth: false },
      component: () => import("./views/Start.vue"),
    },
    {
      path: "/end",
      name: ROUTES.END,
      meta: { skipAuthCheck: true, requiresAuth: false },
      component: () => import("./views/End.vue"),
    },
    {
      path: "/frame",
      name: ROUTES.FRAME,
      component: () => import("./views/Frame.vue"),
    },
    {
      path: "/redirect",
      name: ROUTES.REDIRECT,
      meta: { skipAuthCheck: true, requiresAuth: false },
      component: () => import("./views/Redirect.vue"),
    },
    {
      path: "/confirm-message",
      name: ROUTES.SIGN_MESSAGE,
      meta: { title: "walletFrontend.signMessage", skipAuthCheck: true, requiresAuth: false },
      component: () => import("./views/SigningMessage.vue"),
    },
    {
      path: "/confirm-transaction",
      name: ROUTES.SIGN_TRANSACTION,
      meta: { title: "Sign Transaction", skipAuthCheck: true, requiresAuth: false },
      component: () => import("./views/SigningTransaction.vue"),
    },
    {
      path: "/wallet",
      component: () => import("./views/Wallet.vue"),
      children: [
        {
          path: "",
          redirect: "wallet/home",
          meta: { layout: LAYOUT.MAIN, title: "walletFrontend.home" },
        },
        {
          path: "home",
          name: ROUTES.HOME,
          meta: { layout: LAYOUT.MAIN, title: "walletFrontend.home" },
          component: () => import("./views/Home.vue"),
        },
        {
          path: "activity",
          name: ROUTES.ACTIVITY,
          meta: { layout: LAYOUT.RAW, title: "walletFrontend.activity" },
          component: () => import("./views/Activity.vue"),
        },
        {
          path: "checkout",
          name: ROUTES.CHECKOUT,
          meta: { layout: LAYOUT.BASIC, title: "portfolio.buy" },
          component: () => import("./views/Checkout.vue"),
        },
        {
          path: "swap",
          name: ROUTES.SWAP,
          meta: { layout: LAYOUT.BASIC, title: "portfolio.swap" },
          component: () => import("./views/Swap.vue"),
        },
        {
          path: "settings",
          name: ROUTES.SETTINGS,
          meta: { layout: LAYOUT.RAW, title: "walletFrontend.settings" },
          component: () => import("./views/Settings.vue"),
        },
        {
          path: "token-details/:contractAddress",
          name: ROUTES.TOKEN_DETAILS,
          meta: { layout: LAYOUT.RAW, title: "walletFrontend.tokenDetails" },
          component: () => import("./views/TokenDetails.vue"),
        },
        {
          path: "nft-details/:contractAddress",
          name: ROUTES.NFT_DETAILS,
          meta: { layout: LAYOUT.RAW, title: "walletFrontend.nftDetails" },
          component: () => import("./views/NFTDetails.vue"),
        },
        {
          path: "transfer-token",
          name: ROUTES.TRANSFER_TOKEN,
          meta: { layout: LAYOUT.RAW, title: "walletFrontend.send" },
          component: () => import("./views/TransferToken.vue"),
        },
        {
          path: "request",
          name: "Request",
          component: () => import("./views/Request.vue"),
        },
      ],
    },
  ],
});

export default router;
